export const contentGenerationPermissions = (actions: Set<string>) => {
  const LIST_CONTENTS = actions.has('author-list-contents')
  const GENERATE_CONTENT = actions.has('author-create-content')

  return {
    GENERATE_CONTENT,
    LIST_CONTENTS,
  } as const
}
